
const digest = 'b6b70c2b30d2a8e8607b376e579f7d0b0a3c6e1ff26f5e0adc2387371628a05c';
const classes = {"container":"_container_11i26_1"};
const css = `._container_11i26_1 {
  display: flex;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  